const initTooltips = () => {
  const buttons = document.querySelectorAll(".form-tooltip__btn");
  if (!buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const openTooltip = document.querySelector(".form-tooltip__text.visible");
      if (openTooltip) {
        openTooltip.classList.remove("visible");
      }
      button.parentElement.querySelector(".form-tooltip__text").classList.add("visible");
      document.addEventListener("click", (evt) => {
        if (!evt.target.closest(".form-tooltip__btn")) {
          button.parentElement.querySelector(".form-tooltip__text").classList.remove("visible");
        }
      })
    })
  })
};

export default initTooltips;
